//Original Code taken from: https://stackoverflow.com/questions/41761523/how-to-convert-json-to-query-string-in-angular2
import { URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map'
import { isNumeric } from 'rxjs/util/isNumeric';

export class QueryStringBuilder {
  static BuildParametersFromSearch<T>(obj: T): URLSearchParams {
    let params: URLSearchParams = new URLSearchParams();

    if (obj == null) {
      return params;
    }

    QueryStringBuilder.PopulateSearchParams(params, '', obj);

    return params;
  }

  private static PopulateArray<T>(params: URLSearchParams, prefix: string, val: Array<T>) {
    for (let index in val) {
      let key = prefix + '[' + index + ']';
      let value: any = val[index];
      QueryStringBuilder.PopulateSearchParams(params, key, value);
    }
  }

  private static PopulateObject<T>(params: URLSearchParams, prefix: string, val: T) {
    const objectKeys = Object.keys(val) as Array<keyof T>;

    if (prefix) {
      prefix = prefix + '.';
    }

    for (let objKey of objectKeys) {

      let value = val[objKey];
      let key = prefix + objKey;

      QueryStringBuilder.PopulateSearchParams(params, key, value);
    }
  }

  private static PopulateSearchParams<T>(params: URLSearchParams, key: string, value: any) {
    if (value instanceof Array) {
      QueryStringBuilder.PopulateArray(params, key, value);
    }
    else if (value instanceof Date) {
      params.set(key, value.toISOString());
    }
    else if (value instanceof Object) {
      QueryStringBuilder.PopulateObject(params, key, value);
    }
    else if (value != null) {
      if (isNumeric(value)) {        
          params.set(key, value.toString());
      }
      else
        params.set(key, value.toString());
    }
  }
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/service/QueryStringBuilder.ts